module.exports = __webpack_public_path__ + "static/media/benzema-jersey.9a90acac.png";